import Campaign from 'entities/campaign/model';
import Deed from 'entities/deed/model';

import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SAVE_EVENT,
  SAVE_SUCCESS,
  SAVE_FAILED,
  SAVE_CAMPAIGN,
  SAVE_PROJECT,
  INCREMENT_STEPPER,
  SET_STEPPER,
  FILE_UPLOADED,
  FETCH_PARTNERS,
  FETCH_PARTNERS_SUCCESS,
  FETCH_PARTNERS_FAILED,
  TRACK_EVENT_COMMUNITY_DEEDS,
} from './constants';

export interface InitAction {
  type: typeof INIT;
  id: string;
  duplicate: boolean;
}
export interface InitSuccessAction {
  type: typeof INIT_SUCCESS;
}
export interface InitFailedAction {
  type: typeof INIT_FAILED;
  error: any;
  errorCode: number;
}
export interface SaveEventAction {
  type: typeof SAVE_EVENT;
  data: any;
}
export interface SaveSuccessAction {
  type: typeof SAVE_SUCCESS;
  deed: Deed;
}
export interface SaveFailedAction {
  type: typeof SAVE_FAILED;
  error: any;
  errorCode: number;
}
export interface SaveCampaignAction {
  type: typeof SAVE_CAMPAIGN;
  data: Campaign;
}
export interface SaveProjectAction {
  type: typeof SAVE_PROJECT;
  data: any;
}
export interface IncrementStepperAction {
  type: typeof INCREMENT_STEPPER;
}
export interface SetStepperAction {
  type: typeof SET_STEPPER;
  step: number;
}
export interface FileUploadedAction {
  type: typeof FILE_UPLOADED;
  file: any;
}
export interface FetchPartnersAction {
  type: typeof FETCH_PARTNERS;
  search: any;
  countryCode: any;
  acceptsDonations: boolean;
}
export interface FetchPartnersSuccessAction {
  type: typeof FETCH_PARTNERS_SUCCESS;
}
export interface FetchPartnersFailedAction {
  type: typeof FETCH_PARTNERS_FAILED;
  error: any;
}
export type DeedFormPageActions =
  | InitAction
  | InitSuccessAction
  | InitFailedAction
  | SaveEventAction
  | SaveSuccessAction
  | SaveFailedAction
  | SaveCampaignAction
  | SaveProjectAction
  | IncrementStepperAction
  | SetStepperAction
  | FileUploadedAction
  | FetchPartnersAction
  | FetchPartnersSuccessAction
  | FetchPartnersFailedAction;

export const initAction = (id: string, duplicate: boolean): InitAction => ({
  type: INIT,
  id,
  duplicate,
});

export const initSuccessAction = (): InitSuccessAction => ({
  type: INIT_SUCCESS,
});

export const initFailedAction = (error: any, errorCode: number): InitFailedAction => ({
  type: INIT_FAILED,
  error,
  errorCode,
});

export const saveEventAction = (data: any): SaveEventAction => ({
  type: SAVE_EVENT,
  data,
});
export const saveSuccessAction = (deed: Deed): SaveSuccessAction => ({
  type: SAVE_SUCCESS,
  deed,
});
export const saveFailedAction = (
  error: any,
  errorCode: number,
  additional?: any
): SaveFailedAction => ({
  type: SAVE_FAILED,
  error,
  errorCode,
  ...additional,
});

export const saveCampaignAction = (data: Campaign): SaveCampaignAction => ({
  type: SAVE_CAMPAIGN,
  data,
});

export const saveProjectAction = (data: any): SaveProjectAction => ({
  type: SAVE_PROJECT,
  data,
});

export const incrementStepperAction = (): IncrementStepperAction => ({
  type: INCREMENT_STEPPER,
});

export const setStepperAction = (step: number): SetStepperAction => ({
  type: SET_STEPPER,
  step,
});

export const fileUploadedAction = (file: any): FileUploadedAction => ({
  type: FILE_UPLOADED,
  file,
});

export const fetchPartnersAction = (
  search: any,
  countryCode: any,
  acceptsDonations: boolean
): FetchPartnersAction => ({
  type: FETCH_PARTNERS,
  search,
  countryCode,
  acceptsDonations,
});

export const fetchPartnersSuccessAction = (): FetchPartnersSuccessAction => ({
  type: FETCH_PARTNERS_SUCCESS,
});

export const fetchPartnersFailedAction = (error: any): FetchPartnersFailedAction => ({
  type: FETCH_PARTNERS_FAILED,
  error,
});

export interface TrackEventAction {
  type: typeof TRACK_EVENT_COMMUNITY_DEEDS;
  addedCommunityIds: string[];
  removedCommunityIds: string[];
  addedOrganizingCommunityIds: string[];
  removedOrganizingCommunityIds: string[];
  deedId?: string;
  userId?: string;
}

export const trackEventAction = (args: {
  addedCommunityIds: string[];
  removedCommunityIds: string[];
  addedOrganizingCommunityIds: string[];
  removedOrganizingCommunityIds: string[];
  deedId?: string;
  userId?: string;
}): TrackEventAction => ({
  type: TRACK_EVENT_COMMUNITY_DEEDS,
  ...args,
});
